module.exports = __webpack_public_path__ + "assets/images/speech-bubbles_purple.svg?c5ae1208ad68b101835ae0cbeda262d2";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/speech-bubbles_purple.svg
// module id = 624
// module chunks = 0